// Shared by the browser and API; keep this module free of server dependencies.
export const MAX_CHUNKED_UPLOAD_FILE_SIZE = 2_000_000_000;
export const DEFAULT_UPLOAD_CHUNK_SIZE = 50 * 1024 * 1024;
// Large chunks travel as raw bytes; small requests retain the existing JSON transport.
export const MAX_JSON_UPLOAD_CHUNK_SIZE = 5 * 1024 * 1024;
